module.exports = __webpack_public_path__ + "media/img/corporate/targeted_email_image2-2b3d05d9e6cf0029afbf8eda0c7f0ab5.png";